import PropTypes from "prop-types";
import { useIntl } from "react-intl";
import { Message } from "primereact/message";
import {
  formatLicenseDay,
  nextLicenseStart,
} from "../../../../helpers/EnterpriseLicenseHelper";

// The organisation's status from the API, styled like the list's status.
const STATUSES = {
  Active: { id: "enterprise_status_active", severity: "success" },
  Deactivated: { id: "enterprise_status_deactivated", severity: "error" },
  Upcoming: { id: "enterprise_status_upcoming", severity: "info" },
  Expired: { id: "enterprise_status_expired", severity: "warn" },
  NoLicense: { id: "enterprise_status_no_license", severity: "warn" },
};

const EnterpriseStatusTag = ({ status, licenses }) => {
  const intl = useIntl();
  const known = STATUSES[status];
  if (!known) {
    return null;
  }
  const next = status === "Upcoming" ? nextLicenseStart(licenses) : null;
  // Upcoming always has a licence still to start; if not, say just Upcoming.
  const id =
    status === "Upcoming" && !next ? "license_state_upcoming" : known.id;
  return (
    <span data-testid="enterprise-status" data-status={status}>
      <Message
        severity={known.severity}
        text={intl.formatMessage({ id }, { date: formatLicenseDay(next) })}
        icon=""
      />
    </span>
  );
};

EnterpriseStatusTag.propTypes = {
  status: PropTypes.string,
  licenses: PropTypes.array,
};

export default EnterpriseStatusTag;
